import { render, staticRenderFns } from "./LeaDropdown.vue?vue&type=template&id=1c282a31&"
import script from "./LeaDropdown.vue?vue&type=script&lang=js&"
export * from "./LeaDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports